if (!customElements.get('noa-bundle')) {
  customElements.define(
    'noa-bundle',
    class NoaBundle extends HTMLElement {
      connectedCallback() {
        this.moneyFormat = this.dataset.moneyFormat || '{{amount_with_comma_separator}} €';
        this.savingsTemplate = this.dataset.savingsTemplate || '';
        this.addEventListener('change', this.onChange.bind(this));
        this.syncQuantityInputs();

        if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
          this.variantChangeUnsubscriber = subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
            if (event.data.sectionId !== this.dataset.section || !event.data.variant) return;
            this.updatePrices(event.data.variant.price);
          });
        }
      }

      disconnectedCallback() {
        this.variantChangeUnsubscriber?.();
      }

      onChange(event) {
        if (!event.target.matches('.noa-bundle__input')) return;
        this.syncQuantityInputs();
      }

      get selectedQuantity() {
        return this.querySelector('.noa-bundle__input:checked')?.value || '1';
      }

      // Keeps a visible quantity selector (if one is ever enabled) in sync so the form never sends two different quantities.
      syncQuantityInputs() {
        document
          .querySelectorAll(`input[name="quantity"][form="${this.dataset.formId}"]:not(.noa-bundle__input)`)
          .forEach((input) => {
            input.value = this.selectedQuantity;
          });
      }

      updatePrices(unitPrice) {
        this.querySelectorAll('.noa-bundle__item').forEach((item) => {
          const qty = parseInt(item.dataset.qty, 10);
          const percent = parseInt(item.dataset.percent, 10) || 0;
          const full = unitPrice * qty;
          // Same rounding as Shopify percentage discounts: per unit, rounded down to the cent.
          const discount = percent > 0 ? Math.floor((unitPrice * percent) / 100) * qty : parseInt(item.dataset.discount, 10);
          const final = Math.max(full - discount, 0);
          const savings = full - final;

          item.querySelector('[data-final]').textContent = this.formatMoney(final);
          const fullEl = item.querySelector('[data-full]');
          fullEl.textContent = this.formatMoney(full);
          fullEl.hidden = savings <= 0;
          const savingsEl = item.querySelector('[data-savings]');
          savingsEl.textContent = this.savingsTemplate
            .replace('[amount]', this.formatMoney(savings))
            .replace('[percent]', `${percent}%`);
          savingsEl.hidden = savings <= 0;
        });
      }

      formatMoney(cents) {
        const formats = {
          amount: [2, ',', '.'],
          amount_no_decimals: [0, ',', '.'],
          amount_with_comma_separator: [2, '.', ','],
          amount_no_decimals_with_comma_separator: [0, '.', ','],
          amount_with_space_separator: [2, ' ', ','],
          amount_no_decimals_with_space_separator: [0, ' ', ','],
          amount_with_apostrophe_separator: [2, "'", '.'],
        };
        const placeholder = /\{\{\s*(\w+)\s*\}\}/;
        const match = this.moneyFormat.match(placeholder);
        const [decimals, thousands, decimal] = formats[match?.[1]] || formats.amount;

        const [integer, fraction] = (cents / 100).toFixed(decimals).split('.');
        const value = integer.replace(/\B(?=(\d{3})+(?!\d))/g, thousands) + (fraction ? decimal + fraction : '');
        return this.moneyFormat.replace(placeholder, value);
      }
    }
  );
}
